<template>
  <div class="delivery-upgrade-hint" v-if="upgrade">
    <span v-if="upgrade.free"
      v-text="$t('checkout-flow-summary-delivery-upgrade-free', { addAmount: upgrade.addAmount.toFixed(2), currencySymbol })"></span>
    <span v-else
      v-text="$t('checkout-flow-summary-delivery-upgrade-save', { addAmount: upgrade.addAmount.toFixed(2), savings: upgrade.savings.toFixed(2), currencySymbol })"></span>
  </div>
</template>

<script setup>
import cartService from "../composables/cartService";
</script>
<script>
export default {
  computed: {
    upgrade() {
      return cartService.deliveryUpgrade ? cartService.deliveryUpgrade.value : null
    }
  }
}
</script>

<style scoped>
.delivery-upgrade-hint {
  background: var(--ion-color-light, #f4f5f8);
  border-left: 3px solid var(--ion-color-success, #2dd36f);
  padding: 0.75rem 1rem;
  margin: 1rem auto;
  font-size: 0.95rem;
  line-height: 1.4;
}
</style>
